export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6855.eeb5f362.jpg";